import { getGiveawayStockStatus, getIsCouponCriterionApplied, GiveawayStockStatus } from '@cart-services/core/couponService'
import { type MergedCouponCriterion } from '@cart-services/types'
import { wordPressHost } from '@utils'
import { CouponCondition } from '../CouponCondition/CouponCondition'
import { CouponConditionListGrid } from './CouponConditionListGrid'

export interface CouponConditionListProps {
  currency?: string
  couponCriterions?: MergedCouponCriterion[]
  showToPromotionButton?: boolean
  isVisitor?: boolean
}

export const CouponConditionList = (props: CouponConditionListProps) => {
  const { couponCriterions, currency, showToPromotionButton = false, isVisitor = false } = props

  return (
    couponCriterions?.map((criterion) => {
      const isReached = getIsCouponCriterionApplied(criterion)
      const giveawayStockStatus = getGiveawayStockStatus(criterion.giveaways)
      const isAllGiveawaySoldOut = giveawayStockStatus === GiveawayStockStatus.ALL_SOLD_OUT
      const shouldShowGiveawayTooltip = criterion.giveaways.length > 0 && criterion.is_repeatable
      return (
        <CouponConditionListGrid key={criterion.id} goPromotionHref={showToPromotionButton && !isAllGiveawaySoldOut ? `${wordPressHost}/promotion/${criterion.coupon_id}` : undefined}>
          <CouponCondition
            displayName={criterion.display_name}
            isApplied={isReached}
            currency={currency}
            moreAmount={criterion.left_amount}
            moreQuantity={criterion.left_quantity ?? criterion.display_criterion_quantity}
            count={criterion.count}
            isRepeatable={criterion.is_repeatable}
            useCssGrid
            showToPromotionButton={showToPromotionButton}
            isVisitor={isVisitor}
            showGiveawayTooltip={shouldShowGiveawayTooltip}
            giveawayStockStatus={giveawayStockStatus}
            tooltipInfo={{
              criterionAmount: criterion.criterion_amount ?? 0,
              criterionQuantity: criterion.criterion_quantity ?? 0,
              giftSelectionCount: criterion.gift_selection_count ?? 0,
            }}
          />
        </CouponConditionListGrid>
      )
    })
  )
}
